import { createMiddleware } from '../../../shared/redux';
import * as AuthService from '../auth-service';
import {
    getUser,
    isSignInFromSignUp,
    rejectSignIn,
    setUser,
} from '../sign-in/sign-in.state';
import { redirectToSplashScreen } from '../splash-screen/splash-screen-state';
import {
    acceptChallengeMfaSetup,
    CHALLENGE_MFA_SETUP_ACCEPTED,
    CHALLENGE_MFA_SETUP_ISSUED,
    CHALLENGE_MFA_SETUP_REJECTED,
    CHALLENGE_MFA_SETUP_SUBMITTED,
    rejectChallengeMfaSetup,
    submitChallengeMfaSetup,
} from './challenge-mfa-setup-state';

export const challengeMfaSetupMiddleware = createMiddleware({
    [CHALLENGE_MFA_SETUP_ISSUED]: () => submitChallengeMfaSetup(),
    [CHALLENGE_MFA_SETUP_SUBMITTED]: state => (
        AuthService.setupTOTP({ user: getUser(state) })
            .then(secretCode => acceptChallengeMfaSetup({ user: getUser(state), secretCode }))
            .catch(error => rejectChallengeMfaSetup({ code: error.code || 'UnknownException', error }))
    ),
    [CHALLENGE_MFA_SETUP_ACCEPTED]: (state, action) => ([
        setUser({ user: action.payload.user }),
        redirectToSplashScreen(),
    ]),
    [CHALLENGE_MFA_SETUP_REJECTED]: (state, action) => (
        rejectSignIn({
            code: action.payload.code,
            error: action.payload.error,
            fromSignUp: isSignInFromSignUp(state),
        })
    ),
});
